import { render, staticRenderFns } from "./contentNotView.vue?vue&type=template&id=1e62455c&"
import script from "./contentNotView.vue?vue&type=script&lang=js&"
export * from "./contentNotView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports